import React from 'react';
import './Componenst.css';
import AddressModel from '../models/AddressModel';
import SearchModel from '../models/SearchModel';
import loading from '../../img/loading.gif';
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { createAddress, showError } from '../ViewCreator';

function Address({ changeSearch, searchModel, setView, addNew = () => {}, isAdd = false }) {

    const personModel = new AddressModel();


    const clearSubmit = () => {
        document.getElementById('descAddress').value = '';
        document.getElementById('flat').value = '';
        document.getElementById('buiding').value = '';
        document.getElementById('street').value = '';
        document.getElementById('np').value = '';
        document.getElementById('ato').value = '';
        document.getElementById('region').value = '';
        personModel.infoAddress = ''
        personModel.descAddress = ''
        personModel.flat = ''
        personModel.buiding = ''
        personModel.street = ''
        personModel.np = ''
        personModel.ato = ''
        personModel.region = ''
        if (searchModel != undefined) {
            searchModel.address.infoAddress = ''
            searchModel.address.descAddress = ''
            searchModel.address.flat = ''
            searchModel.address.buiding = ''
            searchModel.address.street = ''
            searchModel.address.np = ''
            searchModel.address.ato = ''
            searchModel.address.region = ''
        }
    }

    const addSubmit = () => {
        if (personModel.street == undefined || personModel.street == ''){
            showError('Вулиця не може бути пустою')
            return;
          }
    
          if (personModel.buiding == undefined || personModel.buiding == ''){
            showError('Будинок не може бути пустим')
            return;
          }
    
          if (personModel.np == undefined || personModel.np == ''){
            showError('НП не може бути пустим')
            return;
          }
    
          if (personModel.ato == undefined || personModel.ato == ''){
            showError('АТО не може бути пустим')
            return;
          }
    
          if (personModel.region == undefined || personModel.region == ''){
            showError('Регіон не може бути пустим')
            return;
          }
          isUniq()
    }

    const isUniq = () => {
        var path = ip + '/api/address/search';
        personModel.searchModel = new SearchModel()
        var pp = new AddressModel();
        if (personModel.flat != undefined && personModel.flat != ''){
            pp.flat = personModel.flat
        }
        pp.street = personModel.street
        pp.buiding = personModel.buiding
        pp.np = personModel.np
        pp.ato = personModel.ato
        pp.region = personModel.region
        var bd = encryptAes(JSON.stringify(pp))
        const requestOptions = {
          headers: {
            'Content-Type': 'Content-type: text/html'
          },
          credentials: 'include',
          uri: path,
          encoding: 'latin1',
          body: bd,
          method: 'POST'
        };
        fetch(path, requestOptions)
          .then()
          .then(response => { return response.arrayBuffer() })
          .then((buffer) => {
            const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
            const text = decoder.decode(buffer);
            try {
              var result = JSON.parse(text);
               showError(result.msg)
            } catch (error) {
              const decryptedText = decryptAes(text);
              var result = JSON.parse(decryptedText);
              storeKey('test_data', result.key);
    
              if (result.data.length > 0) {
                Swal.fire({
                    title: 'Запис уже існує',
                    //text: "Оновити інформацію?",
                    icon: 'warning',
                    html:
                    'Запис з такими даними вже існує, Ви можете ' +
                    '<a href="/address?id='+result.data[0].id+'" style="color:#FFFFFF;"  target="_blank">переглянути запис</a>',
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: 'ОК',
                      denyButtonText: 'Оновити',
                      background: '#2B2B2B',
                      color: '#FFF'
                    }).then((result) => {
                    })
                  sendSearch()
              } else {
                Swal.fire({
                  title: 'Ви дійсно бажаєте створити новий запис',
                  //text: "Оновити інформацію?",
                  icon: 'question',
                  html:
                  '',
                  showDenyButton: false,
                  showCancelButton: true,
                  confirmButtonText: 'Створити',
                  denyButtonText: 'Оновити',
    
                  background: '#2B2B2B',
                  color: '#FFF'
                }).then((result) => {
                  addNewAddress()
                  })
                
              }
            }
          })
      }

      const addNewAddress = () => {
        var path = ip + '/api/address/add';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
          headers: {
            'Content-Type': 'Content-type: text/html'
          },
          credentials: 'include',
          uri: path,
          encoding: 'latin1',
          body: bd,
          method: 'POST'
        };
        fetch(path, requestOptions)
          .then()
          .then(response => { return response.arrayBuffer() })
          .then((buffer) => {
            const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
            const text = decoder.decode(buffer);
            try {
              var result = JSON.parse(text);
               showError(result.msg)
              
    
            } catch (error) {
              const decryptedText = decryptAes(text);
              var result = JSON.parse(decryptedText);
              storeKey('test_data', result.key);
              if (isAdd) {
                addNew(result.data, 20001)
                clearSubmit()
              } else {
                window.open("/edit/address?id="+result.data, "_self")
              }
            }
          })
      }

    const sendAddressFullScreen = (id) => {
        window.open("/address?id=" + id)
    }

    const sendAddress = (id) => {
        var path = ip + '/api/address/id';
       var bd = encryptAes(id)
           const requestOptions = {
             headers: {
               'Content-Type': 'Content-type: text/html; charset=win1251'
             },
             credentials: 'include',
             uri: path,
             encoding: 'latin1',
             body: bd,
             method: 'POST'
           };
           fetch(path, requestOptions)
           .then()
           .then(response => { return response.arrayBuffer() })
           .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []
                
                    var addr = result.data
                    
                    zz.push(createAddress(addr))
    
                    String.prototype.replaceAt = function(index, replacement) {
                        return this.substr(0, index) + replacement + this.substr(index + replacement.length);
                      }
                      var spr =  document.createElement('div');
                      spr.className = "spravka"
                      
                      spr.innerHTML = "<hr><p>"+addr.infoAddress.replace(/\r\n/g, "<p>"); 
                      zz.push(spr)
    
                    setView(zz)
                }
            })
    }


    const handleSubmit = (e) => {
        sendSearch();
        e.preventDefault();
    }

    const sendSearch = () => {
        var path = ip + '/api/address/search';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []

                    for (let index = 0; index < result.data.length; index++) {
                        var z = document.createElement('div'); // is a node
                        var addr = result.data[index]
                        var i = addr.id
                        z.className = "listItem"
                        z.innerHTML = "<p align=\"left\">" + addr.region + " " + addr.ato + " " + addr.np + "<br>" + addr.street + "   " + addr.buiding + "   " + addr.flat;
                        z.style.display = "block";
                        const cl = i => () => {
                            sendAddress(i)
                        }
                        const dblcl = i => () => {
                            sendAddressFullScreen(i)
                        }
                        //z.onclick = cl(addr.id)
                        z.ondblclick = dblcl(addr.id)
                        var per = new AddressModel()
                        per.id = addr.id
                        z.value = per
                        zz.push(z);
                    }
                    changeSearch(zz)
                }
            })
    }

    const handleKeyPress = (event) => {
        event = event || window.event;
        if (event.key === 'Tab') {
            closeAllHelp();
        }
        if (event.key === 'Enter') {
            closeAllHelp();
        }
        if (event.key === 'Escape') {
            closeAllHelp();
        }
    }
    const closeAllHelp = () => {
        var a = document.getElementsByClassName("list");
        for (let index = 0; index < a.length; index++) {
            a[index].innerHTML = "";
        }
    }
    const changedfield = (id) => {
        var input = document.getElementById(id)
        if (input != null) {
            if (input.value.length > 0) {
                document.getElementById(id + "List").innerHTML = "";
                sendHelp(input.value, id);
            } else {
                document.getElementById(id + "List").innerHTML = "";
            }
        }
    }

    const sendHelp = (value, id) => {
        var path = ip + '/api/help/';
        var bd = encryptAes(JSON.stringify({
            "value": value,
            "type": id
        }))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                     showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    var l = result.data.list;
                    for (let index = 0; index < l.length; index++) {
                        var z = document.createElement('div'); // is a node
                        z.className = "listItem"
                        z.innerHTML = l[index];
                        z.style.display = "block";
                        z.href = "#";
                        z.onclick = () => {

                            document.getElementById(id).value = l[index]
                            document.getElementById(id + "List").innerHTML = "";

                            if (id == 'region') {
                                personModel.region = l[index]
                            }
                            if (id == 'ato') {
                                personModel.ato = l[index]
                            }
                            if (id == 'np') {
                                personModel.np = l[index]
                            }
                            if (id == 'street') {
                                personModel.street = l[index]
                            }
                            if (id == 'buiding') {
                                personModel.buiding = l[index]
                            }
                            if (id == 'flat') {
                                personModel.flat = l[index]
                            }
                            if (id == 'descAddress') {
                                personModel.descAddress = l[index]
                            }
                            if (id == 'infoAddress') {
                                personModel.infoAddress = l[index]
                            }

                        }
                        document.getElementById(id + "List").appendChild(z);

                    }
                }
            })








    }

    const regionchange = () => {
        personModel.region = document.getElementById('region').value
        changedfield('region');
    }

    const atochange = () => {
        personModel.ato = document.getElementById('ato').value
        changedfield('ato');
    }

    const npchange = () => {
        personModel.np = document.getElementById('np').value
        changedfield('np');
    }

    const streetchange = () => {
        personModel.street = document.getElementById('street').value
        changedfield('street');
    }

    const buidingchange = () => {
        personModel.buiding = document.getElementById('buiding').value

    }

    const flatchange = () => {
        personModel.flat = document.getElementById('flat').value
    }

    const descAddresschange = () => {
        personModel.descAddress = document.getElementById('descAddress').value
        changedfield('descAddress');
    }

    const handleFocus = (event) => {
        closeAllHelp()
    };

    return (
        <div>
            <button id="clear-button-address" className="clear-button-right" onClick={clearSubmit}>Очистити
            </button>
            <button id="add-button-address" className="add-button-right" onClick={addSubmit}>Додати
            </button>
            <form onSubmit={handleSubmit} className="form">
                <input id="input-button-address" className="input-button-right" type="submit" value="Пошук" />

                <div id="descAddressDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="descAddress" className="input-text" tabIndex="8" name="login" type="text" onChange={descAddresschange} placeholder="Опис" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="descAddressList" className="list" />
                </div>

                <div id="flatDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="flat" className="input-text" tabIndex="8" name="login" type="text" onChange={flatchange} placeholder="Квартира" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="flatList" className="list" />
                </div>
                <div id="buidingDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="buiding" className="input-text" tabIndex="5" name="login" type="text" onChange={buidingchange} placeholder="Будинок" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="buidingList" className="list" />
                </div>
                <div id="streetDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="street" className="input-text" tabIndex="4" name="login" type="text" onChange={streetchange} placeholder="Вулиця" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="streetList" className="list" />
                </div>
                <div id="npDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="np" className="input-text" tabIndex="3" name="login" type="text" onChange={npchange} placeholder="НП (район міста)" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="npList" className="list" />
                </div>
                <div id="atoDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="ato" className="input-text" tabIndex="2" name="login" type="text" onChange={atochange} placeholder="Адмін-територіальна одиниця" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="atoList" className="list" />
                </div>
                <div id="regionDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="region" className="input-text" tabIndex="1" name="login" type="text" onChange={regionchange} placeholder="Регіон" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="regionList" className="list" />
                </div>
            </form>
        </div>
    );
}

export default Address;